'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _safeThrow = require('./safe-throw');

var _safeThrow2 = _interopRequireDefault(_safeThrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var I18N = function () {
    function I18N(config) {
        _classCallCheck(this, I18N);

        var _ref = config || {},
            resources = _ref.resources,
            namespace = _ref.namespace;

        this._resources = resources;
        this._namePrefix = namespace ? namespace + '.' : '';
    }

    I18N.prototype.loadI18n = function loadI18n() {
        this._resources = window._I18N_ || {};
        var elI18ns = document.querySelectorAll('script[type="json/i18n"]');
        for (var i = 0; i < elI18ns.length; i++) {
            try {
                _extends(this._resources, JSON.parse(elI18ns[i].innerHTML));
            } catch (e) {
                (0, _safeThrow2['default'])(e);
            }
        }
    };

    I18N.prototype.createI18n = function createI18n(namespace) {
        return new I18N({ resources: this._resources, namespace: namespace });
    };

    I18N.prototype.get = function get(key) {
        !this._resources && this.loadI18n();
        return this._resources['' + this._namePrefix + key];
    };

    I18N.prototype.getAll = function getAll() {
        var _this = this;

        !this._resources && this.loadI18n();
        var result = {};
        var hasValue = false;
        Object.keys(this._resources).forEach(function (name) {
            if (name.indexOf(_this._namePrefix) !== 0) {
                return;
            }
            result[name.replace(_this._namePrefix, '')] = _this._resources[name];
            hasValue = true;
        });
        return hasValue ? result : null;
    };

    return I18N;
}();

var i18n = new I18N();
exports['default'] = i18n;
module.exports = exports['default'];